import React, { useState, useEffect } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

const EscalationLevelModal = ({ isOpen, onClose, onSubmit, level, loading }) => {
    const [formData, setFormData] = useState({
        section_title: '',
        section_description: '',
        officer_name: '',
        officer_designation: '',
        phone: '',
        email: '',
        resolution_time: '',
        online_portal_url: '',
        postal_address: '',
        is_active: true
    });

    useEffect(() => {
        if (level) {
            setFormData({
                ...level,
                is_active: level.is_active === 1 || level.is_active === true
            });
        }
    }, [level, isOpen]);

    if (!isOpen) return null;

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm">
            <div className="bg-white rounded-3xl shadow-2xl w-full max-w-2xl overflow-hidden animate-in fade-in zoom-in duration-200">
                <div className="flex items-center justify-between px-8 py-6 border-b border-slate-100">
                    <h2 className="text-2xl font-bold text-slate-800">
                        Edit Level {level?.level_number} Details
                    </h2>
                    <button onClick={onClose} className="p-2 hover:bg-slate-100 rounded-full transition-colors">
                        <XMarkIcon className="h-6 w-6 text-slate-500" />
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="p-8 space-y-6 max-h-[70vh] overflow-y-auto">
                    <div>
                        <label className="block text-sm font-semibold text-slate-700 mb-2">
                            Section Title
                        </label>
                        <input
                            required
                            type="text"
                            value={formData.section_title}
                            onChange={(e) => setFormData({ ...formData, section_title: e.target.value })}
                            className="w-full px-4 py-3 border border-slate-200 rounded-2xl focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-semibold text-slate-700 mb-2">
                            Section Description
                        </label>
                        <textarea
                            required
                            rows="3"
                            value={formData.section_description}
                            onChange={(e) => setFormData({ ...formData, section_description: e.target.value })}
                            className="w-full px-4 py-3 border border-slate-200 rounded-2xl focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none"
                        />
                    </div>

                    {level?.level_number === 2 && (
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div>
                                <label className="block text-sm font-semibold text-slate-700 mb-2">
                                    Officer Name
                                </label>
                                <input
                                    required
                                    type="text"
                                    value={formData.officer_name || ''}
                                    onChange={(e) => setFormData({ ...formData, officer_name: e.target.value })}
                                    className="w-full px-4 py-3 border border-slate-200 rounded-2xl focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-semibold text-slate-700 mb-2">
                                    Designation
                                </label>
                                <input
                                    required
                                    type="text"
                                    value={formData.officer_designation || ''}
                                    onChange={(e) => setFormData({ ...formData, officer_designation: e.target.value })}
                                    className="w-full px-4 py-3 border border-slate-200 rounded-2xl focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-semibold text-slate-700 mb-2">
                                    Phone
                                </label>
                                <input
                                    required
                                    type="text"
                                    value={formData.phone || ''}
                                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                                    className="w-full px-4 py-3 border border-slate-200 rounded-2xl focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-semibold text-slate-700 mb-2">
                                    Email
                                </label>
                                <input
                                    required
                                    type="email"
                                    value={formData.email || ''}
                                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                    className="w-full px-4 py-3 border border-slate-200 rounded-2xl focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none"
                                />
                            </div>
                            <div className="md:col-span-2">
                                <label className="block text-sm font-semibold text-slate-700 mb-2">
                                    Resolution Time
                                </label>
                                <input
                                    required
                                    type="text"
                                    value={formData.resolution_time || ''}
                                    onChange={(e) => setFormData({ ...formData, resolution_time: e.target.value })}
                                    className="w-full px-4 py-3 border border-slate-200 rounded-2xl focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none"
                                    placeholder="e.g., Within 30 working days"
                                />
                            </div>
                        </div>
                    )}

                    {level?.level_number === 3 && (
                        <div className="space-y-6">
                            <div>
                                <label className="block text-sm font-semibold text-slate-700 mb-2">
                                    Online Portal URL
                                </label>
                                <input
                                    required
                                    type="url"
                                    value={formData.online_portal_url || ''}
                                    onChange={(e) => setFormData({ ...formData, online_portal_url: e.target.value })}
                                    className="w-full px-4 py-3 border border-slate-200 rounded-2xl focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none"
                                    placeholder="https://..."
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-semibold text-slate-700 mb-2">
                                    Postal Address
                                </label>
                                <textarea
                                    required
                                    rows="5"
                                    value={formData.postal_address || ''}
                                    onChange={(e) => setFormData({ ...formData, postal_address: e.target.value })}
                                    className="w-full px-4 py-3 border border-slate-200 rounded-2xl focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none whitespace-pre-line"
                                    placeholder="Enter full address..."
                                />
                            </div>
                        </div>
                    )}

                    <div>
                        <label className="block text-sm font-semibold text-slate-700 mb-2">
                            Status
                        </label>
                        <button
                            type="button"
                            onClick={() => setFormData({ ...formData, is_active: !formData.is_active })}
                            className={`w-full flex items-center justify-between px-6 py-3 rounded-2xl border transition-all ${formData.is_active
                                ? 'bg-green-50 border-green-200 text-green-700'
                                : 'bg-slate-50 border-slate-200 text-slate-500'
                                }`}
                        >
                            <span className="font-semibold">{formData.is_active ? 'Active' : 'Inactive'}</span>
                            <div className={`w-10 h-6 rounded-full relative transition-all ${formData.is_active ? 'bg-green-500' : 'bg-slate-300'}`}>
                                <div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-all ${formData.is_active ? 'left-5' : 'left-1'}`}></div>
                            </div>
                        </button>
                    </div>
                </form>

                <div className="px-8 py-6 bg-slate-50 border-t border-slate-100 flex justify-end gap-3">
                    <button
                        type="button"
                        onClick={onClose}
                        className="px-6 py-3 rounded-xl font-semibold text-slate-600 hover:bg-slate-200 transition-all"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSubmit}
                        disabled={loading}
                        className="bg-primary-600 hover:bg-primary-700 text-white px-8 py-3 rounded-xl font-semibold transition-all disabled:opacity-50 shadow-lg"
                    >
                        {loading ? 'Saving...' : 'Update Details'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EscalationLevelModal;
